import React from 'react';
import { useTranslation } from 'react-i18next';
import FadeInSection from './FadeInSection';

const AboutSection: React.FC = () => {
  const { t } = useTranslation('website');

  return (
    <section id="about" className="py-24 lg:py-32 relative section-alt">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <FadeInSection className="relative img-overlay">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/3] bg-dark-900 border border-dark-800/50">
              <img
                src="/images/about-company.png"
                alt="About Company"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                  const fallback = (e.target as HTMLImageElement).nextElementSibling as HTMLElement;
                  if (fallback) fallback.style.display = 'flex';
                }}
              />
              <div className="hidden flex-col items-center justify-center h-full gap-4 text-dark-500">
                <i data-lucide="building-2" className="text-5xl text-primary-500/30" />
                <span className="text-sm">Company Image</span>
              </div>
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-gradient-to-br from-accent-500/20 to-transparent rounded-2xl -z-10" />
          </FadeInSection>

          {/* Content */}
          <FadeInSection delay="fade-in-delay-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-[2px] bg-accent-500" />
              <span className="text-accent-400 text-xs font-semibold tracking-wider uppercase">{t('about.label')}</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-extrabold text-white mb-6 leading-snug">
              {t('about.title')}<br />{t('about.titleAccent')}
            </h2>
            <p className="text-dark-300 leading-loose mb-5" style={{ lineHeight: '1.9' }}>
              {t('about.p1')}
            </p>
            <p className="text-dark-400 leading-loose mb-8" style={{ lineHeight: '1.9' }}>
              {t('about.p2')}
            </p>
            <div className="flex flex-wrap gap-3">
              {(t('about.tags', { returnObjects: true }) as string[]).map((tag: string, i: number) => (
                <span key={i} className="px-4 py-2 rounded-xl bg-primary-500/10 border border-primary-500/20 text-sm text-primary-300 font-medium">
                  {tag}
                </span>
              ))}
            </div>
          </FadeInSection>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
